import * as React from "react";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/index";
import { useGetAuthQuery } from "../../reducers/registerapi";
import {
    setCheckoutState,
    setClientId,
    setClientName,
    setToken,
} from "../../reducers/checkout";
import Loading from "../../components/loading";
import CheckoutUserAccount from "./checkoutuseraccount";
import CheckoutUserNotClient from "./checkoutusernotclient";

const CheckoutUser = () => {
    const dispatch = useAppDispatch();
    const { data, isSuccess } = useGetAuthQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });

    useEffect(() => {
        if (isSuccess && data.isAuthenticated && data.isClient) {
            // If we're an authenticated client, then we are logged in and can move on!
            // As soon as we see "start", move to "user"
            dispatch(setClientId(data.clientId));
            dispatch(setClientName(data.clientName));
            dispatch(setToken(data.token));
            console.log("Token", data.token);
            dispatch(setCheckoutState("address"));
        }
    }, [data, isSuccess, dispatch]);

    if (!isSuccess) {
        return (
            <>
                <h3>User Account</h3>
                <Loading />
            </>
        );
    }

    if (!data.isAuthenticated) {
        // not authenticated then either login or create an account
        return <CheckoutUserAccount />;
    }

    if (data.isAdmin) {
        return (
            <CheckoutUserNotClient message="You are logged in to an administrative account so you cannot checkout. Please logout to checkout." />
        );
    }

    if (data.isProvider) {
        return (
            <CheckoutUserNotClient message="You are logged in to a provider account so you cannot checkout. Please logout to checkout." />
        );
    }

    return (
        <>
            <h3>Client Account</h3>
            <Loading />
        </>
    );
};

export default CheckoutUser;
